<template>
    <div>
        <role-assignment-modal
            ref="assignmentModal"
            @saved="saved"
            :user-preset="user"
        />

        <role-assignment-edit-modal
            ref="assignmentEditModal"
            @saved="updated"
            :user-preset="user"
        />

        <div class="tags">
            <template v-for="role in user.visible_roles">
                <div
                    :key="role.id"
                    :class="{
                        'is-link': isEditable(role)
                    }"
                    class="tag is-medium is-wide">
                    <span @click="edit(role)">
                        <!-- <span
                            v-if="isEditable(role)"
                            class="icon">
                            <i class="mdi mdi-pencil"></i>
                        </span> -->
                        <span
                            v-if="role.is_hidden"
                            class="icon">
                            <i class="mdi mdi-eye-off-outline"></i>
                        </span><span
                            v-if="canManage && role.type == 'tag'"
                            class="icon">
                            <i class="mdi mdi-tag"></i>
                        </span><span
                            v-else-if="canManage && role.type != 'tag' && !role.is_updatable"
                            class="icon">
                            <i class="mdi mdi-lock-outline"></i>
                        </span><span>{{ role.title }}</span>
                    </span>
                    <button
                        v-if="canManage"
                        @click="detach(role)"
                        class="delete is-small">
                    </button>
                </div>
            </template>
            <span
                v-if="canManage"
                @click="editRoles"
                class="tag is-medium is-wide is-link">
                <span class="icon">
                    <i class="mdi mdi-pencil"></i>
                </span>
            </span>
            <span
                v-if="canManage"
                @click="editTags"
                class="tag is-medium is-wide is-link">
                <span class="icon">
                    <i class="mdi mdi-tag"></i>
                </span>
            </span>
        </div>
    </div>
</template>

<script>
import RoleAssignmentModal from "../modals/roles/Assignment";
import RoleAssignmentEditModal from "../modals/roles/AssignmentEdit";
import HasUser from "../../mixins/HasUser";

export default Vue.extend({
  mixins: [HasUser],
  props: {
    canManage: {
      // role management ability for given user
      type: Boolean,
      default: false
    }
  },
  components: {
    RoleAssignmentModal,
    RoleAssignmentEditModal
  },
  methods: {
    isEditable(role) {
      return (
        role.type != "tag" &&
        this.canManage &&
        role.scope_rules &&
        Object.keys(role.scope_rules || {}).length > 0
      );
    },
    detach(role) {
      this.$helpers
        .load(axios.delete(`/api/users/${this.user.id}/roles/${role.id}`))
        .then(() => {
          this.refreshUser({
            with: ["roles"]
          });
        });
    },
    editRoles() {
      this.$refs.assignmentModal.open(this.user.type);
    },
    editTags() {
      this.$refs.assignmentModal.open("tag");
    },
    edit(role) {
      if (this.isEditable(role)) {
        this.$refs.assignmentEditModal.open(this.user, role);
      }
    },
    async saved() {
      this.$refs.assignmentModal.close();
      await this.refreshUser({
        with: ["roles"]
      });
    },
    async updated() {
      this.$refs.assignmentEditModal.close();
      await this.refreshUser({
        with: ["roles"]
      });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/users/RoleList.vue